function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.11,42.7s-77-27.37-152.56,16.21S75.85,189,43.1,258.32,29.2,398.12,86.89,430.26,183.81,415,264.74,412.71,367.43,422,434.59,376.26s79.29-153.69,26.32-233.58S342.11,42.7,342.11,42.7Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11,42.7s-77-27.37-152.56,16.21S75.85,189,43.1,258.32,29.2,398.12,86.89,430.26,183.81,415,264.74,412.71,367.43,422,434.59,376.26s79.29-153.69,26.32-233.58S342.11,42.7,342.11,42.7Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138,31V173H385V31ZM376.3,165H146.7V39H376.3Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.52,95s75.73-39.1,81.32-29.17-32.9,35.38-16.76,44.69S313.5,41,329,59.62s-27.93,68.28-14.28,73.87,42.83-21.73,49-14.9-9.93,34.14-3.1,37.86,14.89-3.1,14.89-3.1",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.74,
    cy: 60.24,
    r: 16.76,
    transform: "translate(141.79 299.96) rotate(-76.62)",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.66,
    cy: 53.1,
    r: 9.62,
    transform: "translate(80.69 208.06) rotate(-76.77)",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.39,122.31A4.35,4.35,0,1,1,198,118,4.35,4.35,0,0,1,202.39,122.31Z",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,69.86a4,4,0,1,1-4-4A4,4,0,0,1,357,69.86Z",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.53,
    cy: 147.76,
    r: 11.17,
    transform: "translate(-35.38 142.75) rotate(-26.08)",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.81,
    y1: 248,
    x2: 474.81,
    y2: 248,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.31,
    y1: 261.37,
    x2: 474.81,
    y2: 261.37,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.81,
    y1: 261.37,
    x2: 37.63,
    y2: 261.37,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.7,284.53H328.58a8.52,8.52,0,0,1-8.77,8.25V440.35a8.52,8.52,0,0,1,8.77,8.24,7.33,7.33,0,0,1-.14,1.41H465.9",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.54,284.53H78.63a8.38,8.38,0,0,0,8.51,8.25V440.35a8.38,8.38,0,0,0-8.51,8.24,8.22,8.22,0,0,0,.13,1.41H38.34",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.22,284.53H108.3a8.53,8.53,0,0,1-8.79,8.25V440.35a8.53,8.53,0,0,1,8.79,8.24,7.33,7.33,0,0,1-.14,1.41h187.2a8.22,8.22,0,0,1-.14-1.41,8.52,8.52,0,0,1,8.77-8.24V292.78A8.52,8.52,0,0,1,295.22,284.53Z",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamps--inject-9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 459.81,
    cy: 89.74,
    r: 21.67,
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,81h39.64A21.66,21.66,0,0,0,440,81Z",
    style: {
      fill: "#636363",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460.01,
    y1: 64.02,
    x2: 460.01,
    y2: 22,
    style: {
      fill: "none",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.53,
    y: 62,
    width: 4.56,
    height: 7.6,
    style: {
      fill: "#636363",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.81,
    cy: 89.74,
    r: 21.67,
    style: {
      fill: "#fff",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,81H71.63A21.66,21.66,0,0,0,32,81Z",
    style: {
      fill: "#636363",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.01,
    y1: 64.02,
    x2: 52.01,
    y2: 22,
    style: {
      fill: "none",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.53,
    y: 62,
    width: 4.56,
    height: 7.6,
    style: {
      fill: "#636363",
      stroke: "#636363",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.43,233s.52,65.56.52,82.87-.52,121-.52,121",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.77 249.78 441.51 236.14 487.14 241.38 446.75 228.27 488.19 220.93 441.51 220.93 477.7 193.65 436.79 214.11 460.39 173.72 428.92 209.91 439.93 156.94 419.48 206.24 417.38 151.17 413.19 207.29 390.87 157.71 406.37 212.01 372.98 175.59 402.17 220.4 360.85 190.92 399.55 228.27 355.74 204.33 395.88 231.42 359.57 226.69 394.83 236.66 366.6 241.38 395.88 240.33 378.57 251.87 419.48 240.86 457.77 249.78",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.77 392.77 441.51 379.14 487.14 384.38 446.75 371.27 488.19 363.93 441.51 363.93 477.7 336.65 436.79 357.11 460.39 316.72 428.92 352.91 439.93 299.94 419.48 349.24 417.38 294.17 413.19 350.29 390.87 300.71 406.37 355.01 372.98 318.6 402.17 363.4 360.85 333.92 399.55 371.27 355.74 347.33 395.88 374.42 359.57 369.69 394.83 379.66 366.6 384.38 395.88 383.33 378.57 394.87 419.48 383.86 457.77 392.77",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.69,299.08s-1.57,13.63-.52,18.88a95.73,95.73,0,0,1,1.57,18.36c0,6.81.53,35.79.53,40.51s-.53,44.83-.53,48.5v12.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.27,371.59s2.1-40,4.19-45.24,3.68-3.67,4.2-10,.52-8.91,1.57-11a43.07,43.07,0,0,0,2.1-5.77l1.05-4.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.51 312.71 425.25 299.08 470.88 304.32 430.49 291.21 471.93 283.87 425.25 283.87 461.44 256.59 420.53 277.05 444.13 236.66 412.66 272.85 423.68 219.88 403.22 269.18 401.12 214.11 396.93 270.23 380.67 219.35 390.11 274.95 361.26 233.51 385.91 283.34 348.07 258.62 383.29 291.21 344.24 275.23 379.62 294.36 342.97 291.19 378.57 299.6 353.82 305.24 379.62 303.27 362.31 314.81 403.22 303.8 441.51 312.71",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.33,423.05,377.1,441.77a12.35,12.35,0,0,0-1.34,9.55l5,18.59a6.19,6.19,0,0,0,6,4.59h51.14a6.19,6.19,0,0,0,6-4.59l5-18.59a12.3,12.3,0,0,0-1.34-9.55l-11.22-18.72a4.26,4.26,0,0,0-3.64-2.05H392A4.23,4.23,0,0,0,388.33,423.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.32,157.5s.24-11.06,1-12.79,2.7-4.42,4.18-4.91a55.29,55.29,0,0,0,6.64-2.46,79.5,79.5,0,0,0,6.15-5.66s3.93-1,4.18.25-5.66,6.64-5.66,6.64l2.46,1,13,.25,7.62-7.63s2.7-1.72,2.46,0-7.63,11.31-8.36,11.31-22.14,7.87-22.14,7.87l-2.46,9.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,146.44s5.16-1.48,5.9-2.71,6.15-12,6.64-12.79-2.7-.24-3.93,0-4.68,10.82-4.68,10.82l-5.41,1.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.54,144.56s5.36-.33,6.34-1.37,8.61-10.44,9.25-11.05-2.59-.83-3.84-.85-6.9,9.55-6.9,9.55l-5.66.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.74,150.86s-.24-4.92,2.95-7.38,13.28-2.7,13.28-2.7,4.92-9.59,6.15-9.59,4.18-1.23,3.94,0-3.2,6.15-4.43,8.61-1.72,5.65-2.95,6.64-8.36,2.7-8.36,2.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.38 165.62 353.09 156.52 365.38 158.49 362.43 169.8 350.38 165.62",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,155.78s10.82,2.95,12.79,6.64,18.44,30.25,19.43,32,1.72,3.2,1.72,3.2,12.05-29.27,12.54-31,4.67-2.21,5.9-2.21,12.54.74,13,3.69-14.27,59-15.74,60.25-5.41,1.72-7.87,1-34.68-17-34.68-17Z",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.89,197.59A75.72,75.72,0,0,0,331,210",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.79,208.93c-.24.65-.47,1.34-.67,2.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.22,201.28a23,23,0,0,0-3.34,5.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.85,252l-8.79,103.09-5.41,89.57s-3,3.72-2.7,5.41,2,6.42,2,6.42-5.07,14.54-3.71,15.55a35.93,35.93,0,0,0,4.05,2.37h13.86s2.7-2.71,2.37-4.74-2.37-14.19-2.37-14.19a62.45,62.45,0,0,0,3.38-6.76c.34-1.35-1.69-8.45-1.69-8.45l32.45-124.38s13.85,77.73,17.23,95.65,10,62.39,10,62.39h7.1l1-3s.34-.67,3.72,1.35a11.18,11.18,0,0,0,6.42,1.69h17.58s1.35-1.69.34-2-14.87-9.7-17.24-11.73-6.42-7.43-6.42-7.43,2.36-6.09,2.36-7.1-3-6.76-3-6.76l-2.21-90.56,1-94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.17,152l-21.35,10.24,10.34,66.46-1,26.38s17.72,9.7,37.76,9.07a98.3,98.3,0,0,0,35.24-7.81l1.05-57.6s-2.11-28.06-4.64-32.7-3.8-6.75-7.38-9.49-14.56-5.91-14.56-5.91S267.75,149,267.11,149,252.17,152,252.17,152Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.45 176.27 288 198.96 290.95 172.17 282.09 159.3 275.55 174.07 275.45 176.27",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283 163.81 290.54 173.98 292.51 152.01 287.92 146.44 283 163.81",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.45 129.38 257.09 147.42 283 163.81 294.15 133.32 255.45 129.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.43,140.08a28,28,0,0,0,12.13,2.27c9-.39,19.44-4.4,24.73-6.7l.86-2.33-38.7-3.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283 163.81 275.45 176.27 252.17 152.01 255.78 146.11 283 163.81",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.51,236.2s9.59-8.12,10.82-8.12,7.38,4.67,7.38,4.67,6.14-.73,6.39.74-1,5.66-1,5.66l-1.48,1.47s-4.18,6.4-4.18,7.38-5.41.74-7.87,1.23-9.34-1.23-9.34-1.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.16 235.46 314.48 235.71 314.72 247.51 305.38 247.76 303.16 235.46",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,185.51a19.3,19.3,0,0,0-7.44-15.14c-3.94-3.07-8.84-6.76-10.52-7.46-2.95-1.23-4.42-.74-8.6,2.22s-5.66,9.09-5.41,19.18,7.37,63.2,8.11,65.41,3,2.71,4.92,2.95,69.76-2.07,71.07-2.21c4.68-.49,5.44-6.86,5.17-9.84-.49-5.41-5.17-7.13-12.3-7.87s-42-4.91-43.28-5.16a16.62,16.62,0,0,1-2.46-.74s.74-28.77.74-36.64C251,188.45,251,186.9,251,185.51Z",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.83,235.58a13.59,13.59,0,0,0-2,2.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.29,226.85a50.75,50.75,0,0,0-10.43,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.3,232.26s5.66-7.62,14.51-5.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.59,
    y: 104.86,
    width: 2.28,
    height: 21.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.11,
    y: 126.33,
    width: 17.24,
    height: 0.98,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.73,106.82h0A8.79,8.79,0,0,1,350,98L351.7,82.1h14.06L367.51,98A8.79,8.79,0,0,1,358.73,106.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.55,70.56,386.74,52h-6.91L379,70.56a17.61,17.61,0,0,1-1,5.23l-4,11a19.34,19.34,0,0,0-1.18,6.65v35.89h21V93.42a19.34,19.34,0,0,0-1.18-6.65l-4-11A17.61,17.61,0,0,1,387.55,70.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.72,
    y: 97.43,
    width: 19,
    height: 25.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.46,68.34a.86.86,0,0,1,0-.16l-.65-14.69A1.55,1.55,0,0,0,385.25,52h-3.93a1.57,1.57,0,0,0-1.56,1.49l-.64,14.69s0,.11,0,.16Z",
    style: {
      fill: "#8c8c8c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.9 131.19 331.69 131.19 326.77 127.25 430.8 127.25 424.9 131.19",
    style: {
      fill: "#8c8c8c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.17 228.38 264.5 286.85 313.51 286.85 314.48 235.71 264.17 228.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,90a12.54,12.54,0,0,1,7.88,6.64c3,5.67,11.08,29.3,11.33,32.5s-3.2,4.19-7.14,6.65-16.74,4.43-23.88,2-8.62-6.4-8.62-6.4-2.71,3.2-7.88-.25-6.15-8.12-4.18-9.85,5.17-.24,5.17-.24-5.42-13.3-4.93-18,.74-9.35,8.62-12.55S279,90,279,90Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.22,100.62s1,3.2,2.21,3.7,7.64-1.48,8.13,1.23-2,7.14-2,7.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.56,117.12s-6.16,5.41-12.31.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.16,
    y1: 108.5,
    x2: 274.05,
    y2: 106.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.83,98.65s-5.41-3-8.12,2.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,98.16s2.46-4.43,6.9-.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.66,107.69c.12.35-.34.81-1,1s-1.32.12-1.43-.23.33-.81,1-1S271.54,107.34,271.66,107.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.68,117.12s1.47,5.17,2.46,5.41,5.17,1,4.92-1.47-4.67-11.08-4.18-14,6.15-7.14,4.92-8.86-3.2-1.48-2.46-2.71,12.55-5.17,17-5.17,6.4-.24,8.37-1.72,4.92-7.39-4.19-7.63-24.12,5.91-29.29,12.8-2.71,12.31-1.24,15S249.68,117.12,249.68,117.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.79 168.78 273.89 166.67 275.93 177.06 284.16 170.77 293.33 174.94 291.64 164.33 283.79 168.78",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.63,220.79l3.23,16.4s1.74,2.48,7.45,5,8.45.49,8.45-3.48-2-25.34-2-25.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.65 226.74 192.42 222.16 191.77 213.34 174.63 220.79 175.65 226.74",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,206.39,78,229l6,4.47s5,.5,8.2-1.74,11.18-20.61,11.18-20.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.19 211.28 100.96 216.28 103.34 211.11 85.71 205.61 84.19 211.28",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.47,337.05s2.32,29.14,2.32,35.44-2.65,20.2-1,27.82,7.29,31.13,7.29,38.75-4.3,21.2-2,23.85,6.63,3.31,7.95,6,2,3.31,4.31,4.31,11.59,1.65,13.58,1,1-2.32-2.32-7-10.93-13.58-12.25-17.55,6.95-35.77,7.28-49-.33-30.14-.33-30.14,4.31-29.81,4.31-35.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.31,348a129.31,129.31,0,0,0,27.57-4.61c.44-3.87.74-7.08.74-8.64l-29.15,2.32S147.85,341.85,148.31,348Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,363.88s-.33,8.61-3.31,13.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.93,474.17c2-.66,1-2.32-2.32-7-.57-.8-1.28-1.73-2.05-2.74-3.93,2.49-9.64.94-11.86-1.56-2-2.28-7.13-7.83-9.44-10.33-.81,4.79-1.35,9-.17,10.33,2.32,2.65,6.63,3.31,7.95,6s2,3.31,4.31,4.31S177.94,474.83,179.93,474.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,337.71s5,31.13,5.63,32.13,0,28.48,3.31,37.76,11.92,38.42,12.25,43S126.6,464.56,122,467.54s-6,5-3,6,13.58,0,17.88-.33,10.08,1.26,11.07-.06-.47-20.15-.47-25.78,1.32-45.71-.66-58.95-4-24.85-4-24.85l.67-27.15-29.15-1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,337.71s.49,3.08,1.18,7.32a93.71,93.71,0,0,0,26,3.12l.29-11.76-29.15-1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,363.21s.66,9.94,4.64,14.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.94,473.12c.38-.51.37-3.43.22-7.17-5.16.74-14.27.27-14.27.27-2.32-4.64-6-2.65-6-2.65l-.68,0a55,55,0,0,1-5.28,4c-4.64,3-6,5-3,6s13.39.93,17.69.6S147,474.44,147.94,473.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.11,311.21l-1,26.83s22.53,6.29,41.74,6.63,44.38-7.62,44.38-7.62l-1.33-29.48-83.13-1.32Z",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,233.71s-18.63,47.36-23.27,83.13c0,0,27.16,7.62,54,6.3s42.73-8.61,42.73-8.61-8.28-55-22-77.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.44,89.63s-1.33-8.61-9.94-6.95-8.28,4.64-9.6,7.62-20.21,6.62-24.51,17.88,6.29,14.91,6.29,20.87-13.25,10.6-10.27,17.55,13.91,8.28,12.92,10.6-8.94,6-3,11.26,32.79,10.6,47,7.95,17.89-13.91,15.24-17.55-4.64-5.3-2.65-9,12.25-7.28,8.94-17.22S170.65,121.1,171,115.47s10.26-9.27,2-17.22S152.44,89.63,152.44,89.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.67,159.19l-26.82,7.7,14.9,66.82s7,4.47,22.11,5.47a109.07,109.07,0,0,0,29.31-2.49l14.66-67.32-25.59-8.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.47,160.68l-1,.28,10.55,77.62,1,.14Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.34,159.24l-.67-.05-.32.09L136.84,239l1,.08Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.36,159.72l-1-.07,6.18,79.66,1,0Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.37,162.43l-1,.28L129.65,238l1,.19Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,164.26,125.33,237l1.07.27L112,164Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.23,160.69l-1-.07,1.31,78.54,1-.06Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.32,235.4c.34.14.71.28,1.1.42l-14.88-70.28-1,.28Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.22,166.61l-9.61,70.82,1-.19,9.54-70.32Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.62,168.35l-1-.31-12.24,69,1-.23Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.37,165.06l-1-.31-8,73.38,1-.15Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.35,161.21l-.11,0-.88-.07L152.68,239l1-.08Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,239.35l1,0-2.73-79.09-1-.07Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.14,163.07l-1-.32-5.29,75.85,1-.12Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.46,
    y: 182.31,
    width: 15.52,
    height: 6.57,
    rx: 2.85,
    transform: "translate(10.09 -8.36) rotate(3.05)",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.67,159.19l-26.82,7.7,14.9,66.82s7,4.47,22.11,5.47a109.07,109.07,0,0,0,29.31-2.49l14.66-67.32-25.59-8.19Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.46 140.57 132.03 154.68 142 162.4 151.94 154.61 155.93 141.51 142.75 145.46 131.46 140.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93,141.51l-13.18,4-11.29-4.89.29,7.19c2.37,3.2,4.79,5.76,6.41,6.46,4,1.69,6.21.94,7.53-.38,1-1,6.05-4.1,9.81-10.93Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.49 165.98 140.31 170.12 138.43 206.06 143.88 206.25 142 170.31 146.52 164.66 141.55 159.95 137.49 165.98",
    style: {
      fill: "#FC968B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.95 150.73 141.31 159.95 134.91 170.68 126.06 159.2 130.95 150.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.48 158.47 135.61 169.51 136.15 168.6 127.01 157.56 126.48 158.47",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.5 154.98 127.96 155.92 136.69 167.69 137.24 166.76 128.5 154.98",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.22 150.97 130.95 150.73 130.45 151.6 139.72 161.92 138.32 163.62 129.78 152.76 129.25 153.69 138.23 165.11 140.5 161.3 131.22 150.97",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.95 150.73 141.31 159.95 134.91 170.68 126.06 159.2 130.95 150.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.11 150.73 141.55 159.95 148.7 170.68 158.58 159.2 153.11 150.73",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.11 158.47 147.92 169.51 147.31 168.6 157.52 157.56 158.11 158.47",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.86 154.98 156.46 155.92 146.7 167.69 146.09 166.76 155.86 154.98",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.82 150.97 153.11 150.73 153.68 151.6 143.32 161.92 144.88 163.62 154.42 152.76 155.02 153.69 144.98 165.11 142.44 161.3 152.82 150.97",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.11 150.73 141.55 159.95 148.7 170.68 158.58 159.2 153.11 150.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.61,119.8s-3.18-2.76-4.5.44,3.77,11.48,5.27,11.11.57-11.11.57-11.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.38,120.17s3.51-2.33,4.41,1-5.21,10.9-6.65,10.33.86-11.08.86-11.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.92,94.27S128.08,97.1,126.76,105c-1.2,7.17-1.7,20.33-.38,26.35s10,18.82,13.93,20.51,6.21.94,7.53-.38,9.59-6.21,12.79-18.44,2.83-21.26.76-30.49C160.11,96.86,146.52,89.94,136.92,94.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39,102.55c-1.28-5.69-14.87-12.61-24.47-8.28,0,0-8.84,2.83-10.16,10.73a104.83,104.83,0,0,0-1.15,14.8c.44-1.52,1.07-4,1.71-7.27,1.13-5.84,3.58-10.54,7.72-10.92s5.83,1.51,12.61,1.13,9-.94,11.85,2.26,2.45,13.74,3.2,16.75A58.54,58.54,0,0,0,161.39,102.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,125.51l-.38,4.33s2.07,1.32,1.51,2.83-2.83,2.25-3.77,1.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,138.69s4.52,2.44,7.53,2.07a13.7,13.7,0,0,0,5.83-2.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.24,123.73c0,1.19-.55,2.16-1.23,2.16s-1.22-1-1.22-2.16.55-2.17,1.22-2.17S138.24,122.53,138.24,123.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.86,124.38c0,1.2-.55,2.17-1.22,2.17s-1.23-1-1.23-2.17.55-2.16,1.23-2.16S153.86,123.19,153.86,124.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16,118.36s3-4,8.28-1.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.15,117.61s5.08-3.39,10,1.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.85 166.89 82.22 207.63 106.57 213.84 109.55 202.41 101.85 166.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.38 169.37 85.24 208.4 86.22 208.65 102.74 171.03 102.38 169.37",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8,175.93l-.37-1.73c-4.76,11.81-11,27-14.47,35.15l1,.24C93.85,200.52,100.56,184,103.8,175.93Z",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.15 182.11 104.77 180.4 92.58 210.27 93.55 210.52 105.15 182.11",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.52 206.33 109.55 202.41 109.49 202.13 104.03 213.19 105.02 213.44 108.52 206.33",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.29 196.6 107.91 194.88 100.8 212.37 101.77 212.61 108.29 196.6",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.61 188.85 106.23 187.12 96.51 211.27 97.48 211.52 106.61 188.85",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.85 166.89 82.22 207.63 106.57 213.84 109.55 202.41 101.85 166.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.83 169.37 198.97 215.82 173.88 225.02 172.15 218.56 182.83 169.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.15 195.53 176.76 197.32 185.5 220.76 186.43 220.42 177.15 195.53",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.74 202.01 175.35 203.8 182.18 221.98 183.12 221.63 175.74 202.01",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.59 207.32 174.19 209.16 179.14 223.09 180.08 222.75 174.59 207.32",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.4 223.73 173.33 213.12 172.94 214.89 176.47 224.07 177.4 223.73",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.99 177.84 180.59 179.7 193.84 217.71 194.78 217.36 180.99 177.84",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.34 171.63 181.92 173.54 196.28 216.81 197.22 216.47 182.34 171.63",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.91 182.79 179.51 184.65 191.3 218.64 192.23 218.29 179.91 182.79",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.32 190.1 177.94 191.86 188.78 219.56 189.72 219.22 178.32 190.1",
    style: {
      fill: "#FC968B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.83 169.37 198.97 215.82 173.88 225.02 172.15 218.56 182.83 169.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.54,189.74,106.81,193l-4.72,10.19,2.74,7.7s-25.09,14.41-26.58,15.9-2,11.67,1.24,16.64,16.89-9.94,16.89-9.94l22.36-30.05s5.46-6.46,4-8.2-2.73-3-3.48-3-2.48.25-2.48.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.05,182.66l5.7,11.8,2.24.75-6.33-13.29a.89.89,0,0,0-1.3-.37h0A.9.9,0,0,0,111.05,182.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.34 198.44 107.81 211.11 121.47 213.59 125.69 211.11 120.97 196.7 103.34 198.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,200.92l-17.89-1.49s-2.48-1.74.75-3.73a8.13,8.13,0,0,1,6-1.24l12.67.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.69,208.37l-4-12.67s-4-1.24-5.22,1a3,3,0,0,0,1,4.22c.74.5,3.22-1.24,3.22-1.24l2.74,10.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.76,232.47a28.48,28.48,0,0,1,.75,7.45c0,5-1.24,8.7-4.47,8.7s-16.89-4-23.1-7.21-31.3-15.65-31.3-15.65-8.95-1-11.43-1.49a29.42,29.42,0,0,1-9.19-4c-2.49-1.74-3.73-6.71-3.73-6.71s-4.47-2.73-4.47-4,12.17,1.24,14.41,1.24,5.46-2.49,5.46-2.49l-1.24-4.72s4.47,1.74,5.71,3.23,5.72,9.94,6.46,10.93S157.24,227,167.43,228s20.12,2.48,20.12,2.48",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24.61,
    y1: 474.5,
    x2: 16.54,
    y2: 474.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 489.68,
    y1: 474.5,
    x2: 33.83,
    y2: 474.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.22664ec960d5a60838026ab552911143.svg";
export { ForwardRef as ReactComponent };